import { DeviceUtils } from '@modules/src/utils/DeviceUtils'

//## Short side alone cannot separate tablets from phones: several Android tablets report a
//## narrower CSS width than an iPad (Galaxy Tab S4 is 712, Tab S9/S10/S11 land in the 750-800
//## range, iPad mini is 744), while the largest phones stay around 440. Pairing it with the long
//## side keeps big phones out without raising the short-side bar back above those tablets.
const TABLET_MIN_SHORT_SIDE_PX = 700
const TABLET_MIN_LONG_SIDE_PX = 950

/**
 * Browser chrome eats into the viewport — mostly in landscape, where it can drop a tablet's
 * short side below the threshold and flip the layout on rotation. Screen size is not affected by
 * it, so the larger of the two is used per axis, each normalised to short / long first so a
 * rotated phone cannot borrow its long side from the other source.
 */
const readDeviceSides = (): { short: number; long: number } => {
    const viewportWidth = window.visualViewport?.width || window.innerWidth || 0
    const viewportHeight = window.visualViewport?.height || window.innerHeight || 0
    const screenWidth = Number(window.screen?.width) || 0
    const screenHeight = Number(window.screen?.height) || 0

    return {
        short: Math.max(Math.min(viewportWidth, viewportHeight), Math.min(screenWidth, screenHeight)),
        long: Math.max(Math.max(viewportWidth, viewportHeight), Math.max(screenWidth, screenHeight)),
    }
}

/** Tablet / iPad: touch device whose screen is at least a tablet's, in either orientation. */
export const isTabletViewport = (): boolean => {
    if (!DeviceUtils.isMobileDevice()) {
        return false
    }

    const { short, long } = readDeviceSides()

    return short >= TABLET_MIN_SHORT_SIDE_PX && long >= TABLET_MIN_LONG_SIDE_PX
}
